import { render } from "./sub_amount_display.vue?vue&type=template&id=454b05ca"
import script from "./sub_amount_display.vue?vue&type=script&lang=js"
export * from "./sub_amount_display.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__